// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__21IBU","title":"BackImages_title__Rz43G","images":"BackImages_images__1eZXH"};